

import parseISO from "date-fns/parseISO";
import {JsonAny} from "../../Types";
import {parseVideoReaction, VideoReaction} from "./VideoReaction";
import {parseVideoComment, VideoComment} from "./VideoComment";
import {parseVideoCaption, VideoCaption} from "./VideoCaption";
import {parseVideoExtraMaterial, VideoExtraMaterial} from "./VideoExtraMaterial";
import {VideoTag} from "./VideoTag";

export type ReactionType = "LIKE" | "CHEERS" | "SURPRISED";
export const REACTION_TYPES: ReactionType[] = ["LIKE", "CHEERS", "SURPRISED"];

export type VideoCaptionLanguage = "ja-jp" | "en-us";

export interface Video {
    hash: string;
    id: number;
    imageUrl: string;
    sourceUrl: string;
    fileName: string;
    title: string;
    description: string;
    presenterId: string;
    presenter: string;
    durationMillis: number;
    viewCount: number;
    status: string;
    tags: VideoTag[];
    reactions: VideoReaction[];
    comments: VideoComment[];
    captions: VideoCaption[];
    extraMaterials: VideoExtraMaterial[];
    created: Date;
    updated: Date;
    viewingActivities: ViewingActivity[];
    visibleNewIcon: boolean;
    slideFlg: boolean;
    videoSlides: VideoSlide[];
    projectIds: number[];
    publicCaption: boolean;
    language: string;
    supportLanguage: Map<string, string>;
}

// 視聴履歴
export interface ViewingActivity {
    id: number;
    videoId: string;
    userId: string;
    created: string;
    progressMillis: number;
    isFinished: boolean;
}

export interface VideoChangeSet {
    title: string;
    description: string;
    presenter: string;
    tags: VideoTag[];
}

// ビデオアップロード
export interface AddVideoInfo {
    file: any;
    imageFile?: any;
    documentFile: File[];
    documentName: string[];
    video: VideoInfo;
}

export interface VideoInfo{
    title: string;
    description: string;
    presenter: string;
    language: string;
    filename: string;
    tags?: string[];
}

export interface EditVideoInfo {
    userId: string;
    file?: any;
    imageFile?: any;
    materialId: number[];
    documentFile: File[];
    documentName: string[];
    video: EditInfo;
}

export interface UploadDocumentIF {
    userId: string;
    videoId: number;
    materialId: number[];
    documentFile: File[];
    documentName: string[];
}

export interface EditInfo {
    id: number;
    title: string;
    description: string;
    imageUrl: string;
    presenter: string;
    language: string;
    tags?: string[];
    isPublic: boolean;
    allowedUserIds: string[];
    allowedUserGroupIds: string[];
    presenters: string[];
}

export interface VideoPDF {
    slideUrl: string;
    slideName: string;
    isPublic: boolean;
    videoSlides: VideoSlide[];
}
export interface VideoSlide {
    slideId: number;
    startMillis: number;
    videoId: number;
}
export interface UpdateVideoSlideIF {
    videoId: number;
    file: File | null;
    slideName: string;
    isPublic: boolean;
    videoSlides: VideoSlide[];
}

export function parseVideo(json: JsonAny): Video {
    return {
        ...json,
        extraMaterials: json.extraMaterials.map(parseVideoExtraMaterial),
        captions: json.captions.map(parseVideoCaption),
        comments: json.comments.map(parseVideoComment),
        reactions: json.reactions.map(parseVideoReaction),
        created: parseISO(json.created),
        updated: parseISO(json.updated)
    };
}
